import React from 'react';
import '../applications-css/Application.css'
import "../applications-css/Checkers.css";
import win_icon from "../icons/check-0.png";
const blackCircle = <span role="img" aria-label="blackCircle" data-testid="blackCircle">⚫</span>
const redCircle = <span role="img" aria-label="redCircle" data-testid="redCircle">🔴</span>
const blackKing = <span role="img" aria-label="blackSquare" data-testid="blackKing">⬛</span>
const redKing = <span role="img" aria-label="redSquare" data-testid="redKing">🟥</span>
const moveMarker = <span role="img" data-testid="whiteCircle">O</span>


class Checkers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 8,
      width: 8,
      currentPlayer: "black",
      currentLocation: [],
      jumpLock: false,
      board: []
    }
    this.cellClickHandler = this.cellClickHandler.bind(this);
  }

  componentDidMount() {
    let array = [];
    this.create2dBoard(array);
    this.setState({
      board: array,
      jumpLock: false
    });
  }

  create2dBoard(array) {
    for(let i = 0; i < this.state.width; i++) {
      let newRow = new Array(this.state.height);
      for(let j = 0; j < this.state.height; j++) {
        if(i === 0 && j % 2 === 1) {
          newRow[j] = {color: "black", piece: blackCircle};
        }
        else if(i === 1 && j % 2 === 0) {
          newRow[j] = {color: "black", piece: blackCircle};
        }
        else if(i === 2 && j % 2 === 1) {
          newRow[j] = {color: "black", piece: blackCircle};
        }
        else if(i === 5 && j % 2 === 0) {
          newRow[j] = {color: "red", piece: redCircle};
        }
        else if(i === 6 && j % 2 === 1) {
          newRow[j] = {color: "red", piece: redCircle};
        }
        else if(i === 7 && j % 2 === 0) {
          newRow[j] = {color: "red", piece: redCircle};
        }
        else {
          newRow[j] = {color: "", piece: ""};
        }
      }
      array.push(newRow);
    }
  }

  createBoard() {
    let cellClickHandler = this.cellClickHandler;
    let currentLocation = this.state.currentLocation;
    let jumpLock = this.state.jumpLock;
    return(
      <div id="checkersGrid">
      {this.state.board.map(function(row, xIndex) {
        return row.map(function(cell, yIndex) {
          let spaceColor = "White";
          if((xIndex % 2) === (yIndex % 2)) {
            spaceColor = "Black";
          }
          return(
            <CheckersSquare
              location={[xIndex, yIndex]}
              currentLocation={currentLocation}
              content={cell}
              squareColor={spaceColor}
              jumpLock={jumpLock}
              cellClickHandler = {cellClickHandler}
              key={[xIndex, yIndex]}
            />
          );
        })
      })}
      </div>
    )
  }

  isValidSpace(x, y) {
    if(x > this.state.width - 1 || y > this.state.height - 1) {
      return false;
    }
    else if(x < 0 || y < 0) {
      return false;
    }
    else {
      return true;
    }
  }

  cellClickHandler(location) {
    let x = location[0];
    let y = location[1];
    let deltas = [];
    let tempBoard = this.state.board;
    if(this.state.board[x][y].piece === blackKing || this.state.board[x][y].piece === redKing) {
        deltas = [[-1, -1], [-1, 1], [1, -1], [1, 1]];
    }
    else if(this.state.currentPlayer === "red") {
      deltas = [[-1, -1], [-1, 1]];
    }
    else {
      deltas = [[1, -1], [1, 1]];
    }
    if(this.state.board[x][y].color === this.state.currentPlayer) {
      this.removeOldMovableSpaces(tempBoard);
      this.findMovableSpaces(x, y, deltas, tempBoard);
      this.findJumpableSpaces(x, y, deltas, tempBoard);
      this.setState({
        board: tempBoard,
        currentLocation: location
      })
    }
    if(this.state.board[x][y].piece === moveMarker) {
      this.movePiece(location, deltas, tempBoard);
      this.kingCheck(tempBoard, x, y);
    }
  }

  movePiece(location, deltas, tempBoard) {
    let x = location[0];
    let y = location[1];
    this.removeOldMovableSpaces(tempBoard);
    let nextPlayer = (this.state.currentPlayer === "black") ? "red" : "black";
    let oldX = this.state.currentLocation[0];
    let oldY = this.state.currentLocation[1];
    let pieceToMove = tempBoard[oldX][oldY];
    tempBoard[oldX][oldY] = {color: "", piece: ""};
    tempBoard[x][y] = pieceToMove;
    if(Math.abs(x - oldX) > 1 ||  Math.abs(y - oldY) > 1) {
      this.takePiece(oldX, x, oldY, y, tempBoard, deltas, nextPlayer);
    }
    else {
      this.setState({
        board: tempBoard,
        currentPlayer: nextPlayer,
        currentLocation: [],
        jumpLock: false,
      })
    }
    let pieceCount = this.pieceCount();
    if(pieceCount[0] === 0 || pieceCount[1] === 0) {
      this.winHandler();
    }
  }

  kingCheck(tempBoard, x, y) {
    let kingableRow = (this.state.currentPlayer === "black") ? 7 : 0;
    if(x === kingableRow) {
      let kingColor = (this.state.currentPlayer === "black") ? blackKing : redKing;
      tempBoard[x][y].piece = kingColor;
    }
  }

  takePiece(oldX, x, oldY, y, tempBoard, deltas, nextPlayer) {
    let takenX = Math.floor((oldX + x) / 2);
    let takenY = Math.floor((oldY + y) / 2);
    tempBoard[takenX][takenY] = {color: "", piece: ""};
    if(this.findJumpableSpaces(x, y, deltas, tempBoard) === true) {
      this.setState({
        board: tempBoard,
        currentLocation: [x, y],
        jumpLock: true,
      })
    }
    else {
      this.setState({
        board: tempBoard,
        currentPlayer: nextPlayer,
        currentLocation: [],
        jumpLock: false,
      })
    }
  }

  findMovableSpaces(x, y, deltas, newArray) {
    for(let i = 0; i < deltas.length; i++) {
      let newX = x + deltas[i][0];
      let newY = y + deltas[i][1];
      if(this.isValidSpace(newX, newY) === true) {
        if(newArray[newX][newY].piece === "") {
          newArray[newX][newY] = {color: "", piece: moveMarker};
        }
      }
      else {
        continue;
      }
    }
  }

  findJumpableSpaces(x, y, deltas, newArray) {
    let opponentColor = (this.state.currentPlayer === "black") ? "red" : "black";
    let foundJumps = false;
    for(let i = 0; i < deltas.length; i++) {
      let newX = x + deltas[i][0];
      let newY = y + deltas[i][1];
      if(this.isValidSpace(newX, newY) === true) {
        if(newArray[newX][newY].color === opponentColor) {
          let tempX = x + (2 * deltas[i][0]);
          let tempY = y + (2 * deltas[i][1]);
          if(this.isValidSpace(tempX, tempY) === true && newArray[tempX][tempY].piece === "") {
            newArray[tempX][tempY] = {color: "", piece: moveMarker};
            foundJumps = true;
          }
        }
      }
      else {
        continue;
      }
    }
    return foundJumps;
  }

  removeOldMovableSpaces(tempBoard) {
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        if(tempBoard[i][j].piece === moveMarker) {
          tempBoard[i][j] = {color: "", piece: ""};
        }
      }
    }
  }

  pieceCount() {
    let blackPieces = 0;
    let redPieces = 0;
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        let space = this.state.board[i][j];
        if(space.color === "black") {
          blackPieces++;
        }
        if(space.color === "red") {
          redPieces++;
        }
      }
    }
    return [blackPieces, redPieces]
  }

  winHandler() {
    if(this.state.blackPieces < this.state.redPieces) {
      this.props.appLauncherHandler(null, "Popup Window", this.redWinMessage);
    }
    else {
      this.props.appLauncherHandler(null, "Popup Window", this.blackWinMessage);
    }
  }

  blackWinMessage() {
    return(
      <span>
        <img width="32" src={win_icon} draggable="false" alt={""}/>
        <p>Black wins! Open a new window to play again.</p>
      </span>
    );
  }

  redWinMessage() {
    return(
      <span>
        <img width="32" src={win_icon} draggable="false" alt={""}/>
        <p>Red wins! Open a new window to play again.</p>
      </span>
    );
  }

  render() {
    return(
      <div id="checkersWrapper" className="outsideWrapper">
        <div id="checkersHeader">
            <button className="unclickedButton" data-testid="current-player" style={{pointerEvents: "none",}}>
            Player: {this.state.currentPlayer}
          </button>
        </div>
        {this.createBoard()}
      </div>
    )
  }
}

class CheckersSquare extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(location) {
    this.props.cellClickHandler(location);
  }

  render() {
    // let pointerEvents = "auto";
    let pointerEvents = "none";
    if(this.props.jumpLock === true) {
      if(this.props.content.piece === moveMarker) {
        pointerEvents = "auto";
      }
      if(this.props.location === this.props.currentLocation) {
        pointerEvents = "auto";
      }
    }
    else {
      if(this.props.content.piece !== "") {
        pointerEvents = "auto";
      }
    }
    let buttonClass = (this.props.squareColor === "Black") ? "clickedButton" : "unclickedButton";
    let buttonTitle = "cell-[" + this.props.location + "]"
    return(
      <div id="checkersCell">
        <button className={buttonClass} ref="checkersButton"
          data-testid={buttonTitle}
          onClick = {() => this.clickHandler(this.props.location)}
          style={{
            pointerEvents: pointerEvents,
            fontWeight: "bold"
          }}
        >
          {this.props.content.piece}
        </button>
      </div>
    )
  }
}

export default Checkers;
